<template>
    <div class="loading_container">
        <v-icon class="loading_icon" name="circle-notch" scale="2" spin></v-icon>
        <h2 style="margin-top:20px;">{{ $t('loading')}}</h2>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>